import { connectToStores } from 'fluxible-addons-react';
import { QUANTUM_UI } from '../../../flags';
import NavigationStore from '../../stores/NavigationStore';
import canUseStore from '../../util/canUseStore';
import { DefinitionTooltip } from './DefinitionTooltip';
import { DefinitionTooltip as DefinitionTooltipOld } from './DefinitionTooltip.old';
export default connectToStores(QUANTUM_UI ? DefinitionTooltip : DefinitionTooltipOld, [NavigationStore], function (context, _a) {
    var dataKey = _a.dataKey;
    if (!canUseStore(context))
        return {};
    var glossary = context.getStore(NavigationStore).glossary;
    var term = glossary && dataKey && glossary.termsById[dataKey];
    return { term: term };
});
export * from './styles';
